const MEXICO_CITY_LOCATION = { LAT: 19.4326, LNG: -99.1332 }
const DEFAULT_ZOOM = 15
const libraries: Array<'geometry'> = ['geometry']

export const googleMapsConfig = {
  apiKey: process.env.GOOGLE_MAPS_API_KEY ?? '',
  libraries: libraries,
  defaultZoom: DEFAULT_ZOOM,
  defaultCenter: MEXICO_CITY_LOCATION,
  pin: {
    defaultColor: '#916EE8'
  },
  defaultDirectionsRendererOptions: {
    suppressMarkers: true,
    polylineOptions: {
      strokeColor: '#916EE8',
      strokeWeight: 5
    }
  },
  defaultOptions: {
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    zoomControl: false
  }
}
